module.exports = __webpack_public_path__ + "img/message-icon.06e202f5.svg";